import _ from 'lodash';

import { enums } from 'console-kit';

const LIGHTBOX_LAUNCH_METHOD = {
  BUTTON: 'button',
  LINK:   'link',
  EVENT:  'event',
};
LIGHTBOX_LAUNCH_METHOD.ALL = _.values(LIGHTBOX_LAUNCH_METHOD);

const LIGHTBOX_EVENT_CONFIG_TYPE = {
  PAGE_LOAD:    'page-load',
  EXIT_INTENT:  'exit-intent',
  TIME_ON_PAGE: 'time-on-page',
  SCROLL:       'scroll',
};
LIGHTBOX_EVENT_CONFIG_TYPE.ALL = _.values(LIGHTBOX_EVENT_CONFIG_TYPE);

const DEFAULT_LIGHTBOX_TRANSPARENCY = 50;

const DEFAULT_INNETWORK_X_DIMENSION = 1600;
const DEFAULT_INNETWORK_Y_DIMENSION = 900;

const OVERLAY_SIZES = {
  SMALL:      'small',
  MEDIUM:     'medium',
  LARGE:      'large',
  FULLSCREEN: 'fullscreen',
};

const OVERLAY_SIZE_LIST = [
  { label: 'Small', value: OVERLAY_SIZES.SMALL },
  { label: 'Medium', value: OVERLAY_SIZES.MEDIUM },
  { label: 'Large', value: OVERLAY_SIZES.LARGE },
  { label: 'Full Screen', value: OVERLAY_SIZES.FULLSCREEN },
];

const DEFAULT_OVERLAY_SIZE = OVERLAY_SIZES.MEDIUM;

const DISPLAY_OVERLAY_POSITIONS = {
  TOP_LEFT:      'topLeft',
  TOP_CENTER:    'topCenter',
  TOP_RIGHT:     'topRight',
  CENTER_LEFT:   'centerLeft',
  CENTER:        'center',
  CENTER_RIGHT:  'centerRight',
  BOTTOM_LEFT:   'bottomLeft',
  BOTTOM_CENTER: 'bottomCenter',
  BOTTOM_RIGHT:  'bottomRight',
};

const OVERLAY_POSITIONS = {
  [DISPLAY_OVERLAY_POSITIONS.TOP_LEFT]:      enums.positions.inSquare.TOP_LEFT,
  [DISPLAY_OVERLAY_POSITIONS.TOP_CENTER]:    enums.positions.inSquare.TOP_CENTER,
  [DISPLAY_OVERLAY_POSITIONS.TOP_RIGHT]:     enums.positions.inSquare.TOP_RIGHT,
  [DISPLAY_OVERLAY_POSITIONS.CENTER_LEFT]:   enums.positions.inSquare.MIDDLE_LEFT,
  [DISPLAY_OVERLAY_POSITIONS.CENTER]:        enums.positions.inSquare.CENTERED,
  [DISPLAY_OVERLAY_POSITIONS.CENTER_RIGHT]:  enums.positions.inSquare.MIDDLE_RIGHT,
  [DISPLAY_OVERLAY_POSITIONS.BOTTOM_LEFT]:   enums.positions.inSquare.BOTTOM_LEFT,
  [DISPLAY_OVERLAY_POSITIONS.BOTTOM_CENTER]: enums.positions.inSquare.BOTTOM_CENTER,
  [DISPLAY_OVERLAY_POSITIONS.BOTTOM_RIGHT]:  enums.positions.inSquare.BOTTOM_RIGHT,
};

const DEFAULT_OVERLAY_POSITION = DISPLAY_OVERLAY_POSITIONS.CENTER;

export default {
  LIGHTBOX_LAUNCH_METHOD,
  LIGHTBOX_EVENT_CONFIG_TYPE,
  DEFAULT_LIGHTBOX_TRANSPARENCY,
  DEFAULT_OVERLAY_SIZE,
  DEFAULT_INNETWORK_X_DIMENSION,
  DEFAULT_INNETWORK_Y_DIMENSION,
  OVERLAY_SIZES,
  OVERLAY_SIZE_LIST,
  OVERLAY_POSITIONS,
  DEFAULT_OVERLAY_POSITION,
};
